import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedText, formatText } from 'core/i18n';
import { recordEventCustomOnly } from 'utilities/uTagging';

export const WorkActivityQuestion = ({ showModal, isDocumentAccepted, isDocumentRead }) => {
    const isModalOpenedAndNotRead = isDocumentRead === true && isDocumentAccepted === false;

    const informationClassName = isModalOpenedAndNotRead
        ? 'workactivityquestion-information--not-readed'
        : 'workactivityquestion-information';

    const buttonNotReadClassName = isModalOpenedAndNotRead ? 'workactivityquestion-button--not-readed' : '';

    useEffect(() => {
        if (isModalOpenedAndNotRead) {
            recordEventCustomOnly({
                categoriaEvento: 'eventos onboarding',
                accionEvento: 'errorMessage',
                etiquetaEvento: 'debes leer la informacion legal',
                categoriaError: 'leer la informacion legal',
                descripcionError: formatText('uploads-workActivityInfo'),
            });
        }
    }, [isModalOpenedAndNotRead]);

    const handleClickReadButton = () => {
        showModal();
        recordEventCustomOnly({
            categoriaEvento: 'eventos onboarding',
            accionEvento: 'clickButton',
            etiquetaEvento: 'leer informacion legal',
        });
    };
    const buildContent = () => {
        if (isDocumentAccepted) {
            return (
                <>
                    <div className="workactivityquestion-information-link">
                        <i className="icon-check" />
                        <div onClick={showModal}>
                            <FormattedText value="uploads-workActivityInfoRead" />
                        </div>
                    </div>
                    <div className="workactivityquestion-readed">
                        <FormattedText value="field-buttonReadOk" />
                    </div>
                </>
            );
        }

        return (
            <>
                <div className={informationClassName}>
                    <FormattedText value="uploads-workActivityInfo" />
                </div>
                <div className="workactivityquestion-button">
                    <button
                        type="button"
                        className={`form__button form__button-primaryB ${buttonNotReadClassName}`}
                        onClick={handleClickReadButton}
                    >
                        <FormattedText value="uploads-workActivityReadLegalInfo" />
                    </button>
                </div>
            </>
        );
    };

    return (
        <div className="workactivityquestion-container">
            <div className="workactivityquestion-title">
                <FormattedText value="uploads-workActivityTitle" />
            </div>
            <div className="workactivityquestion-content">{buildContent()}</div>
        </div>
    );
};

WorkActivityQuestion.propTypes = {
    showModal: PropTypes.func,
    isDocumentRead: PropTypes.bool,
    isDocumentAccepted: PropTypes.bool,
};
